import { render } from "./DNSRecords.vue?vue&type=template&id=4459e71f&scoped=true"
import script from "./DNSRecords.vue?vue&type=script&lang=js"
export * from "./DNSRecords.vue?vue&type=script&lang=js"

import "./DNSRecords.vue?vue&type=style&index=0&id=4459e71f&scoped=true&lang=css"

import exportComponent from "/home/ben/Projects/harborwall-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4459e71f"]])

export default __exports__